// Password Toggle Module for Shopify
class PasswordToggle {
    constructor() {
        this.init();
    }

    init() {
        // Find all password toggle buttons
        const toggleButtons = document.querySelectorAll('.password-toggle');
        
        toggleButtons.forEach(button => {
            // Get the field ID from aria-controls attribute
            const fieldId = button.getAttribute('aria-controls');
            
            if (fieldId) {
                // Remove any existing onclick handlers
                button.removeAttribute('onclick');
                
                // Add click event listener
                button.addEventListener('click', () => {
                    this.togglePassword(fieldId, button);
                });
            }
        });
    }

    /**
     * Toggle password visibility
     * @param {string} fieldId - The ID of the password field
     * @param {Element} button - The toggle button element
     */
    togglePassword(fieldId, button) {
        const passwordField = /** @type {HTMLInputElement} */ (document.getElementById(fieldId));
        const eyeOpen = /** @type {HTMLElement} */ (button.querySelector('.eye-open'));
        const eyeClosed = /** @type {HTMLElement} */ (button.querySelector('.eye-closed'));

        if (!passwordField || passwordField.tagName !== 'INPUT') return;

        if (passwordField.type === 'password') {
            passwordField.type = 'text';
            if (eyeOpen) eyeOpen.style.display = 'none';
            if (eyeClosed) eyeClosed.style.display = 'block';
        } else {
            passwordField.type = 'password';
            if (eyeOpen) eyeOpen.style.display = 'block';
            if (eyeClosed) eyeClosed.style.display = 'none';
        }
    }
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new PasswordToggle();
    });
} else {
    // DOM is already ready
    new PasswordToggle();
}

// Export for potential external use
export { PasswordToggle };